// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SummaryChart__wrapper__PcA1s","cashArea":"SummaryChart__cashArea__nXtpX","cryptoArea":"SummaryChart__cryptoArea__iBRYd"};